module.exports = __webpack_public_path__ + "static/media/enlarge.63f7ea21.svg";